import { Navigate, Route, Routes } from 'react-router-dom'

import { APP_ENV } from '@/config'
import { AnonymousLayout, MainLayout, Page403, Page404 } from '@/layouts'
import { lazyImport } from '@/utils/lazyimport'

import { AuthorizedRoute } from './AuthorizedRoute'
import { ROUTER_PRIVATE_LINKS, ROUTER_PUBLIC_LINKS } from './config'
import { PublicRoute } from './PublicRoute'
import { SecureRoute } from './SecureRoute'

const { Auth } = lazyImport(() => import('@/features/auth'), 'Auth')
const { Signin } = lazyImport(() => import('@/features/auth'), 'Signin')
const { Registration } = lazyImport(() => import('@/features/auth'), 'Registration')
const { CodeVerification } = lazyImport(() => import('@/features/auth'), 'CodeVerification')
const { Home } = lazyImport(() => import('@/features/home'), 'Home')
const { Devices } = lazyImport(() => import('@/features/devices'), 'Devices')
const { DeviceDetails } = lazyImport(() => import('@/features/devices'), 'DeviceDetails')
const { Store } = lazyImport(() => import('@/features/store'), 'Store')
const { Calculator } = lazyImport(() => import('@/features/store'), 'Calculator')
const { Stock } = lazyImport(() => import('@/features/stock'), 'Stock')
const { Sites } = lazyImport(() => import('@/features/sites'), 'Sites')
const { SiteCreation } = lazyImport(() => import('@/features/sites'), 'SiteCreation')
const { SiteDetails } = lazyImport(() => import('@/features/sites'), 'SiteDetails')
const { SpareParts } = lazyImport(() => import('@/features/spareparts'), 'SpareParts')
const { Statistics } = lazyImport(() => import('@/features/statistics'), 'Statistics')
const { Profile } = lazyImport(() => import('@/features/profile'), 'Profile')
const { Cgu } = lazyImport(() => import('@/features/legal'), 'Cgu')

function AppRoutes() {
  return (
    <Routes>
      {/* Legal routes: public, unauthenticated, no app layout (consumed by the mobile webview too) */}
      <Route element={<Cgu />} path={ROUTER_PUBLIC_LINKS.legal_cgu.path} />
      <Route element={<Cgu />} path={ROUTER_PUBLIC_LINKS.legal_cgu_lang.path} />

      {/* Public routes */}
      <Route element={<PublicRoute />}>
        <Route element={<AnonymousLayout />}>
          <Route element={<Auth />} path={ROUTER_PUBLIC_LINKS.auth.path}>
            <Route element={<Navigate to={ROUTER_PUBLIC_LINKS.authSignin.path} replace />} index />
            <Route element={<Signin />} path="signin" />
            <Route element={<Registration />} path="register" />
            <Route element={<CodeVerification />} path="otp" />
          </Route>
        </Route>
      </Route>

      {/* Private routes */}
      <Route element={<SecureRoute />}>
        <Route element={<MainLayout />} path="/">
          <Route element={<Navigate to={ROUTER_PRIVATE_LINKS.home.path} />} index />

          {AuthorizedRoute(Home, ROUTER_PRIVATE_LINKS.home)}
          {AuthorizedRoute(Store, ROUTER_PRIVATE_LINKS.store)}
          {AuthorizedRoute(Calculator, ROUTER_PRIVATE_LINKS.calculator)}
          {AuthorizedRoute(SpareParts, ROUTER_PRIVATE_LINKS.spareparts)}
          {AuthorizedRoute(Profile, ROUTER_PRIVATE_LINKS.profile)}
          {APP_ENV !== 'prd' && (
            <>
              {AuthorizedRoute(Devices, ROUTER_PRIVATE_LINKS.devices)}
              {AuthorizedRoute(DeviceDetails, ROUTER_PRIVATE_LINKS.deviceDetails)}
              {AuthorizedRoute(Stock, ROUTER_PRIVATE_LINKS.stock)}
              {AuthorizedRoute(Sites, ROUTER_PRIVATE_LINKS.sites)}
              {AuthorizedRoute(SiteCreation, ROUTER_PRIVATE_LINKS.siteCreation)}
              {AuthorizedRoute(SiteDetails, ROUTER_PRIVATE_LINKS.siteDetails)}{' '}
              {AuthorizedRoute(Statistics, ROUTER_PRIVATE_LINKS.statistics)}
            </>
          )}

          <Route element={<Page403 />} path={ROUTER_PUBLIC_LINKS.not_authorized.path} />
          <Route element={<Page404 />} path={ROUTER_PUBLIC_LINKS.not_found.path} />
        </Route>
      </Route>
    </Routes>
  )
}

export default AppRoutes
